import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutLaneBuilderResultsSlideout extends Layout {
    labelCarrierCount: Label;
    labelCarriers: Label;
    labelContacts: Label;
    labelLanes: Label;
    labelOrderCount: Label;
    labelOrdersProcessed: Label;
    panelCarriers: Panel;
    panelOrders: Panel;
    panelResults: Panel;
    panelShadow: Panel;
    sourcePnnBuilderLane: DataSource;
    sourcePnnBuilderSendto: DataSource;
    tableCarriers: Table;
    tableContacts: Table;
    tableLanes: Table;
}
